import { render } from "./MainMenuView.vue?vue&type=template&id=5283340a&scoped=true"
import script from "./MainMenuView.vue?vue&type=script&lang=js"
export * from "./MainMenuView.vue?vue&type=script&lang=js"

import "./MainMenuView.vue?vue&type=style&index=0&id=5283340a&scoped=true&lang=css"

import exportComponent from "E:\\doc\\projects\\copAccraCrusade\\cfan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5283340a"]])

export default __exports__